import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const OrderDetails = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const docRef = doc(db, "orders", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setOrder(docSnap.data());
        }
        setLoading(false);
      } catch (err) {
        console.error("Error fetching order:", err);
        setLoading(false);
      }
    };
    fetchOrder();
  }, [id]);

  const formatTimestamp = (timestamp) => {
    if (!timestamp?.seconds) return "غير متوفر";
    const date = new Date(timestamp.seconds * 1000);
    return date.toLocaleString("ar-EG");
  };

  const calculateTotal = () => {
    if (!order?.items) return 0;
    return order.items.reduce(
      (sum, item) => sum + (item.price * (item.quantity || 1)),
      0
    );
  };

  if (loading) return <p style={styles.loading}>⏳ جاري تحميل الطلب...</p>;
  if (!order) return <p style={styles.error}>❌ لم يتم العثور على الطلب.</p>;

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>🛒 تفاصيل الطلب</h2>
      <p><strong>تاريخ الإنشاء:</strong> {formatTimestamp(order.createdAt)}</p>

      {order.customer && (
        <div style={styles.section}>
          <p><strong>👤 اسم العميل:</strong> {order.customer.name}</p>
          <p><strong>📞 الهاتف:</strong> {order.customer.phone}</p>
          <p><strong>📍 العنوان:</strong> {order.customer.address}</p>
        </div>
      )}

      <p><strong>📌 الحالة:</strong> {order.status}</p>

      <h3 style={styles.subheading}>📝 المنتجات:</h3>
      <ul style={styles.list}>
        {order.items.map((item) => (
          <li key={item.id} style={styles.listItem}>
            <strong>{item.name}</strong> - {item.price} ج.م × {item.quantity || 1} = {(item.price * (item.quantity || 1))} ج.م
            <br />
            {item.description && <span style={styles.meta}>📝 {item.description}</span>}
          </li>
        ))}
      </ul>

      <p style={styles.total}><strong>💰 الإجمالي:</strong> {calculateTotal()} ج.م</p>
    </div>
  );
};

const styles = {
  container: {
    background: "#f9f9f9",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    maxWidth: "700px",
    margin: "30px auto",
    fontFamily: "Tahoma, sans-serif",
    direction: "rtl",
    lineHeight: "1.8",
  },
  heading: {
    color: "#333",
    fontSize: "24px",
    marginBottom: "20px",
    textAlign: "center",
  },
  subheading: {
    fontSize: "20px",
    marginTop: "25px",
    marginBottom: "10px",
    color: "#444",
  },
  section: {
    background: "#fff",
    padding: "15px",
    borderRadius: "8px",
    marginBottom: "15px",
    border: "1px solid #ddd",
  },
  list: {
    listStyleType: "none",
    padding: 0,
  },
  listItem: {
    background: "#fff",
    padding: "10px",
    marginBottom: "10px",
    borderRadius: "6px",
    border: "1px solid #eee",
  },
  meta: {
    fontSize: "14px",
    color: "#666",
  },
  total: {
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "20px",
    textAlign: "center",
    color: "#222",
  },
  loading: {
    textAlign: "center",
    fontSize: "18px",
    marginTop: "50px",
  },
  error: {
    textAlign: "center",
    fontSize: "18px",
    color: "red",
    marginTop: "50px",
  },
};

export default OrderDetails;
